export const GET_LIST_QUANLYTHUCHIHOPDONG = "GET_LIST_QUANLYTHUCHIHOPDONG";
export const GET_LIST_QUANLYTHUCHIHOPDONG_SUCCESS =
  "GET_LIST_QUANLYTHUCHIHOPDONG_SUCCESS";
export const GET_LIST_QUANLYTHUCHIHOPDONG_FAILURE =
  "GET_LIST_QUANLYTHUCHIHOPDONG_FAILURE";

export const UPDATE_SEARCHTDATA_QUANLYTHUCHIHOPDONG =
  "UPDATE_SEARCHTDATA_QUANLYTHUCHIHOPDONG";
